<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Nome da Gerência"
              v-model="form.filters.nome"
              maxlength="40"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              label="Sigla da Gerência"
              v-model="form.filters.sigla"
              maxlength="40"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-select
              label="Secretaria Executiva"
              :items="form.lists.secretarias"
              :item-text="'nome'"
              :item-value="'identificador'"
              v-model="form.filters.secretaria"
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col cols="2">
            <v-text-field
              label="Setor"
              v-model="form.filters.setor"
              maxlength="40"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <sigfoco-select-ativo
            :cols="2"
            v-model="form.filters.ativo"
            labelType="Situação"
          ></sigfoco-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sigfoco-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarOrganograma()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterOrganograma()"
            ></sigfoco-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        ref="table"
        class="mt-5"
        item-key="id"
        :headers="headers"
        :items="form.lists.organogramas"
        :footer-props="$footerProps"
        :items-per-page="10"
        show-expand
      >
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nome }}
        </template>
        <template v-slot:[`item.sigla`]="{ item }">
          {{ item.sigla }}
        </template>
        <template v-slot:[`item.secretariaExecutiva`]="{ item }">
          {{ item.secretariaExecutiva.nome }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <sigfoco-label-ativo-inativo :ativo="item.ativo"></sigfoco-label-ativo-inativo>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="funcoes" :colspan="headers.length">
            <v-chip-group active-class="primary--text" column>
              <v-chip class="chip-permissao" v-for="(setor, i) in item.setores" :key="i">
                <v-icon class="funcao" small>mdi-account-multiple</v-icon>
                {{ setor.nome }}
              </v-chip>
            </v-chip-group>
          </td>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sigfoco-tooltip
            :text="'Visualizar Organograma'"
            :icon="'mdi-eye-outline'"
            small
            @click="openDialogVisualizarOrganograma(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="'Editar Organograma'"
            :icon="'mdi-pencil'"
            small
            @click="openDialogManterOrganograma(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="'Excluir Organograma'"
            :icon="'mdi-delete'"
            small
            @click="excluirOrganograma(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="`${item.ativo ? 'Inativar Organograma' : 'Ativar Organograma'}`"
            :icon="`${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`"
            :color="`${item.ativo ? 'var(--primary-button-color)' : 'silver'}`"
            small
            @click="inativarAtivarOrganograma(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="'Detalhar Organograma'"
            :icon="'mdi-source-fork'"
            small
            @click="detalharOrganograma(item)"
          ></sigfoco-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarOrganogramaDialog
      :visible="dialogManterOrganograma.visible"
      :content="dialogManterOrganograma.content"
      :edit="dialogManterOrganograma.edit"
      @onClose="dialogManterOrganograma.close()"
      @onSave="buscarOrganograma()"
    ></CadastrarEditarOrganogramaDialog>
    <VisualizarOrganogramaDialog
      :visible="dialogVisualizarOrganograma.visible"
      :content="dialogVisualizarOrganograma.content"
      @onClose="dialogVisualizarOrganograma.close()"
    ></VisualizarOrganogramaDialog>
  </div>
</template>

<script>
import { Dialog } from "~/commons/classes/dialog";
import { Organograma } from "~/commons/classes/organograma";
import ManterOrganogramaService from "~/services/manter-organograma.service";
import CadastrarEditarOrganogramaDialog from "./dialogs/CadastrarEditarOrganogramaDialog.vue";
import VisualizarOrganogramaDialog from "./dialogs/VisualizarOrganogramaDialog.vue";

export default {
  name: "ManterOrganogramaView",
  mixins: [ManterOrganogramaService],
  components: {
    CadastrarEditarOrganogramaDialog,
    VisualizarOrganogramaDialog,
  },
  data: () => ({
    dialogManterOrganograma: Dialog.Build(),
    dialogVisualizarOrganograma: Dialog.Build(),
    form: {
      filters: {
        nome: null,
        sigla: null,
        setor: null,
        secretaria: null,
        ativo: null,
      },
      lists: {
        organogramas: [],
        secretarias: [],
      },
    },
    headers: [
      { text: "Nome da Gerência", align: "center", value: "nome" },
      { text: "Sigla da Gerência", align: "center", value: "sigla" },
      { text: "Secretaria Executiva", align: "center", value: "secretariaExecutiva" },
      { text: "Setor", align: "center", value: "data-table-expand" },
      { text: "Situação", align: "center", value: "ativo" },
      { text: "Ações", align: "center", value: "acoes", sortable: false },
    ],
  }),
  methods: {
    buscarOrganograma() {
      this.$buscarOrganograma({ params: this.form.filters }).then(({ data }) => this.form.lists.organogramas = data.itens);
    },
    openDialogManterOrganograma(organograma) {
      if (organograma) {
        this.$visualizarOrganograma(organograma.id).then(({ data }) => this.dialogManterOrganograma.open(new Organograma(data.resposta), true));
      } else {
        this.dialogManterOrganograma.open(Organograma.Build());
      }
    },
    openDialogVisualizarOrganograma(organograma) {
      this.dialogVisualizarOrganograma.open(organograma);
    },
    buscarSecretariasExecutivas() {
      this.$obterSecretariasExecutivas().then(({ data }) => this.form.lists.secretarias = data.itens);
    },
    detalharOrganograma(organograma) {
      this.$router.push({ path: `detalhar-organograma/${organograma.id}` });
    },
    excluirOrganograma(organograma) {
      this.$swal({
        text: `Confirmar a exclusão do organograma?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$excluirOrganograma({ id: organograma.id }, organograma.id).then(
          ({ data }) => {
            this.$notifySuccess(`${data.mensagem}`);
            this.buscarOrganograma();
          }
        );
      });
    },
    inativarAtivarOrganograma(organograma) {
      this.$swal({
        text: `Confirmar a ${organograma.ativo ? "inativação" : "ativação"} do organograma?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarOrganograma({ id: organograma.id }, organograma.id).then(({ data }) => {
          this.$notifySuccess(`${data.mensagem}`);
          this.buscarOrganograma();
        });
      });
    },
    resetForm() {
      if (this.$refs.table) {
        this.$refs.table.expanded = [];
      }
      this.$resetForm();
      this.form.lists.organogramas = [];
      this.form.filters.ativo = null;
    },
  },
  mounted() {
    this.buscarSecretariasExecutivas();
  },
};
</script>
